import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plane, Lock, Mail, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { authAPI } from '../../services/adminApi';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await authAPI.login(formData.email, formData.password);
      toast.success('Giriş başarılı!');
      navigate('/admin');
    } catch (err) {
      toast.error(err.message || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: '#0F172A' }}>
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center" style={{
            background: 'rgba(0, 240, 255, 0.15)',
            boxShadow: '0 0 30px rgba(0, 240, 255, 0.4)'
          }}>
            <Plane size={40} style={{ color: '#00F0FF' }} />
          </div>
          <h1 className="text-3xl font-bold" style={{
            color: '#F8FAFC',
            textShadow: '0 0 20px rgba(0, 240, 255, 0.5)'
          }}>Kartal Air</h1>
          <p className="mt-2" style={{ color: '#94A3B8' }}>Admin Panel</p>
        </div>

        {/* Form Card */}
        <div className="glass-card p-8">
          <h2 className="text-xl font-semibold mb-6 text-center" style={{ color: '#F8FAFC' }}>
            Admin Girişi
          </h2>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm mb-2" style={{ color: '#F8FAFC' }}>E-posta</label>
              <div className="relative">
                <Mail size={18} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: '#64748B' }} />
                <input
                  type="email"
                  name="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-3 text-white focus:outline-none transition-all duration-300"
                  style={{
                    background: 'rgba(15, 23, 42, 0.8)',
                    border: '1px solid rgba(0, 240, 255, 0.3)',
                  }}
                  placeholder="E-posta adresiniz"
                  data-testid="admin-email-input"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm mb-2" style={{ color: '#F8FAFC' }}>Şifre</label>
              <div className="relative">
                <Lock size={18} className="absolute left-3 top-1/2 -translate-y-1/2" style={{ color: '#64748B' }} />
                <input
                  type="password"
                  name="password"
                  required
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-3 text-white focus:outline-none transition-all duration-300"
                  style={{
                    background: 'rgba(15, 23, 42, 0.8)',
                    border: '1px solid rgba(0, 240, 255, 0.3)',
                  }}
                  placeholder="••••••••"
                  data-testid="admin-password-input"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 font-semibold uppercase tracking-wide transition-all duration-300 flex items-center justify-center gap-2"
              style={{
                background: 'linear-gradient(90deg, #00F0FF 0%, #0F172A 100%)',
                color: '#F8FAFC',
                border: '2px solid #00F0FF',
                boxShadow: '0 0 20px rgba(0, 240, 255, 0.3)',
              }}
              data-testid="admin-submit-btn"
            >
              {loading ? (
                <Loader2 className="w-5 h-5 animate-spin" />
              ) : (
                'Giriş Yap'
              )}
            </button>
          </form>
        </div>

        {/* Back to site */}
        <div className="mt-6 text-center">
          <a href="/" className="text-sm" style={{ color: '#64748B' }}>
            ← Siteye Dön
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
